import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Incoterm } from "@common/models/incoterm";
import { environment } from "environments/environment";

@Injectable({providedIn:'root'})
export class IncotermService{
    constructor(private _http : HttpClient){}

    getAll(){
        return this._http.get<Incoterm[]>(`${environment.commonApiUrl}/api/incoterm`);
    }
}
